import { Component, Input, OnDestroy, OnChanges, AfterViewInit, ViewChild, SimpleChanges } from '@angular/core';

@Component({
	selector: 'port-enable-disable',
	templateUrl: './port-enable-disable.component.html',
	styleUrls: ['./port-enable-disable.component.scss']
})
export class PortEnableDisableComponent {

	constructor() {

	}

}